enum Actions {
  SAVE_SETTINGS = 'saveSettings',
  UPDATE_SETTINGS_STATE = 'updateSettingsState',
  GET_SETTINGS = 'getSettings',
  PATCH_SETTINGS_STATE = 'patchSettings',
  SET_IS_READY = 'setIsReady',
}

export default Actions;
